import React from 'react';

import LoadingSpinner from 'components/common/LoadingSpinner';

const LoadingPage = () =>
  (<div className="loading-page">
    <LoadingSpinner diameter="150px" />
  </div>);

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/common/LoadingPage.js